import React, { useRef, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ScrollToBottom from 'react-scroll-to-bottom';
import logoLoading from '../Res/logo-loading.gif';

const PingModal = ({ isOpen, onCancel, data }) => {
  const messageRef = useRef();

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  });
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Data</ModalHeader>
      <ModalBody>
        <ScrollToBottom className="ping-data-container">
          <div className="ping-container" ref={messageRef}>
            {!!data.length ? (
              data.map(item => {
                return <p>{item}</p>;
              })
            ) : (
              <div className="ping-loading-container">
                <img src={logoLoading} className="loading-logo-sm" alt="loading" />
              </div>
            )}
          </div>
        </ScrollToBottom>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={onCancel}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PingModal;
